import { render, staticRenderFns } from "./ReflectionBox.vue?vue&type=template&id=39af7ee8&scoped=true"
import script from "./ReflectionBox.vue?vue&type=script&lang=js"
export * from "./ReflectionBox.vue?vue&type=script&lang=js"
import style0 from "./ReflectionBox.vue?vue&type=style&index=0&id=39af7ee8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af7ee8",
  null
  
)

export default component.exports